// import React from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import pimg1 from '../../images/clients/client_logo_1.webp'
// import pimg2 from '../../images/clients/client_logo_2.webp'
// import pimg3 from '../../images/clients/client_logo_3.webp'
// import pimg4 from '../../images/clients/client_logo_4.webp'
// import pimg5 from '../../images/clients/client_logo_5.webp'
// import pimg6 from '../../images/clients/client_logo_6.webp'
// import pimg7 from '../../images/clients/client_logo_7.webp'
// import partners from "../../api/partners";

// var settings = {
//     dots: false,
//     infinite: true,
//     speed: 3000,
//     slidesToShow: 7,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 0,
//     cssEase: "linear",
//     arrows: false,

//     responsive: [
//         {
//             breakpoint: 1025,
//             settings: {
//                 slidesToShow: 7,
//                 slidesToScroll: 1,
//             }
//         },
//         {
//             breakpoint: 991,
//             settings: {
//                 slidesToShow: 5,
//                 slidesToScroll: 1
//             }
//         },
//         {
//             breakpoint: 767,
//             settings: {
//                 slidesToShow: 4,
//                 slidesToScroll: 1
//             }
//         },
//         {
//             breakpoint: 600,
//             settings: {
//                 slidesToShow: 3,
//                 slidesToScroll: 1
//             }
//         },
//         {
//             breakpoint: 450,
//             settings: {
//                 slidesToShow: 2,
//                 slidesToScroll: 1
//             }
//         },
//         {
//             breakpoint: 350,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1
//             }
//         }
//     ]
// };

// const PartnerSection = (props) => {

//     return (
//         <div className="client_logo_carousel">
//             <Slider {...settings}>
//                 {partners.map((partner, pitem) => (
//                     <div className="client_logo_item" key={pitem}>
//                         <img src={partner.pImg} alt="Techco - Client Logo" />
//                     </div>
//                 ))}
//             </Slider>
//         </div>
//     );
// }

// export default PartnerSection;

import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import partners from "../../api/partners";
import "./partnerSection.css";

var settings = {
  dots: false,
  infinite: true,
  speed: 3000,
  slidesToShow: 7,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: "linear",
  arrows: false,

  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 7,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 350,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const PartnerSection = (props) => {
  return (
    <div className="section-wrapper">
  <h2 className="text-center mb-4">Collaborating with clients, using innovative tech, backed by certified expertise.</h2>
  <div className="client_logo_carousel widht-100 client_logo_item1_bg">
    <Slider {...settings}>
      {partners.map((partner, pitem) => (
        <div className="client_logo_item" key={pitem}>
          <img
            src={partner.pImg}
            alt="Techco - Client Logo"
            className="client_logo_img1"
          />
        </div>
      ))}
    </Slider>
  </div>
</div>
  );
};

export default PartnerSection;
